import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import { config } from "../../constants/config";
import { TextIndentLeft, TextLeft, TextParagraph, Table } from "react-bootstrap-icons";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function AddDomaine() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [fetching, setFetching] = useState(false);

    const [type, setType] = useState(0);
    const [nomtab, setNomtab] = useState("");
    const [prefdom, setPrefdom] = useState("");
    const [libdom, setLibdom] = useState("");

    const [nomtabparent, setNomtabparent] = useState("");

    const [libtitrevueliste, setLibtitrevueliste] = useState("");
    const [libtitrevuenouveau, setLibtitrevuenouveau] = useState("");
    const [libtitrevueedit, setLibtitrevueedit] = useState("");
    const [domaines, setDomaines] = useState([]);

    const listype = [
        {
            value: 1,
            label: "Domain type 1",
        },
        {
            value: 2,
            label: "Domain type 2",
        },
        // {
        //     value: 3,
        //     label: "Domain type 3",
        // },
        // {
        //     value: 4,
        //     label: "Domain type 4",
        // },
    ];

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showWarningMessage = (msg) => {
        toast.warning(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };


    const getDomaines = async () => {
        // setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/domains?page=1&limit=10000000`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });

                        setDomaines(clientarraydata);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("data error: fail");
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("data error: fail");
            }

        }).catch((err) => {
            // console.log("cash error: ", err);;
        });
    }



    // comportements
    useEffect(() => {
        getDomaines();
    }, [])

    const handleSubmit = async (e) => {

        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        urlencoded.append("nomtab", nomtab);
        urlencoded.append("type", type["value"]);
        // urlencoded.append("pref", prefdom);
        urlencoded.append("lib", libdom);
        if (nomtabparent) urlencoded.append("nomtabparent", nomtabparent["value"]);
        // urlencoded.append("list", libtitrevueliste);
        // urlencoded.append("nouv", libtitrevuenouveau);
        // urlencoded.append("edit", libtitrevueedit);
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/domains`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else if (data?.body?.msg === "libelleexistant") {
                            setFetching(false);
                            showWarningMessage("Ce libelle est déjà utilisé par un autre domaine.");
                        } else {
                            setFetching(false);
                            showErrorMessage(textes.fr.requestfail);
                        }
                    } else {
                        showSuccesMessage("Domaine ajouté avec succès");
                        setFetching(false);
                        navigate(-1);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(config.texts.unavailblemsg);
            setFetching(false);
        });
    }


    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-4 font-weight-bold text_primary">Domains</h1>
            <div className="row">
                <div className="col-md-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                <i className="fa fa-reply"></i> <span>Go Back</span>
                            </button>
                            <h6 className="m-0 ">Informations du domain</h6>
                        </div>
                        <div className="card-body">
                            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <div className="row">
                                            {/* <div className="col-md-6 mb-3">
                                                                <label htmlFor="type" className="mb-1">Type de domaine</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="type">
                                                                        <TypeH1 />
                                                                    </span>
                                                                    <input type="text" 
                                                                        className="form-control" 
                                                                        placeholder=""
                                                                        value={type}
                                                                        onChange={(e) => setType(e.target.value)}
                                                                        disabled={editedstate ? false : true}
                                                                    />
                                                                </div>
                                                            </div> */}
                                            <div className="col-md-6 mb-3">
                                                <label className="mb-1" htmlFor="type">Type de domaine</label>
                                                <Select
                                                    id="type"
                                                    name="type"
                                                    options={listype}
                                                    value={type}
                                                    onChange={(selected) => {
                                                        setType(selected);
                                                        setNomtabparent("");
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="lib" className="mb-1">Libelle</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="lib">
                                                        <TextParagraph />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le libelle du domaine"
                                                        value={libdom}
                                                        onChange={(e) => setLibdom(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="table" className="mb-1">Nom table</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="table">
                                                        <Table />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le nom de la table"
                                                        value={nomtab}
                                                        onChange={(e) => setNomtab(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="pref" className="mb-1">Préfix</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="pref">
                                                        <TextLeft />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le préfix"
                                                        value={prefdom}
                                                        onChange={(e) => setPrefdom(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            {type["value"] === 2 && <div className="col-md-6 mb-3">
                                                <label htmlFor="tableparent1" className="mb-1">Table parent</label>
                                                {/* <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="tableparent1">
                                                                        <Table />
                                                                    </span>
                                                                    <input type="text" 
                                                                        className="form-control" 
                                                                        placeholder=""
                                                                        value={nomtabparent}
                                                                        onChange={(e) => setNomtabparent(e.target.value)}
                                                                    />
                                                                </div> */}
                                                <Select
                                                    id="tableparent1"
                                                    name="tableparent1"
                                                    options={domaines}
                                                    value={nomtabparent}
                                                    onChange={(selected) => { setNomtabparent(selected); }}
                                                />
                                            </div>}
                                            {/* <div className="col-md-6 mb-3">
                                                                <label htmlFor="tableparent2" className="mb-1">Nom table parent niveau 2</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="tableparent2">
                                                                        <Table />
                                                                    </span>
                                                                    <input type="text" 
                                                                        className="form-control" 
                                                                        placeholder=""
                                                                        value={nomtabparent1}
                                                                        onChange={(e) => setNomtabparent1(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label htmlFor="tableparent2" className="mb-1">Nom table parent niveau 2</label>
                                                                <div className="input-group flex-nowrap">
                                                                    <span className="input-group-text" id="tableparent2">
                                                                        <Table />
                                                                    </span>
                                                                    <input type="text" 
                                                                        className="form-control" 
                                                                        placeholder=""
                                                                        value={nomtabparent2}
                                                                        onChange={(e) => setNomtabparent2(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div> */}
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="libtitrevueliste" className="mb-1">Libelle titre vue liste</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="libtitrevueliste">
                                                        <TextIndentLeft />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le titre à afficher lors de l'affichage de la liste"
                                                        value={libtitrevueliste}
                                                        onChange={(e) => setLibtitrevueliste(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="libtitrevuenouveau" className="mb-1">Libelle titre vue nouveau</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="libtitrevuenouveau">
                                                        <TextIndentLeft />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le titre à afficher lors de l'ajout"
                                                        value={libtitrevuenouveau}
                                                        onChange={(e) => setLibtitrevuenouveau(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="libtitrevueedit" className="mb-1">Libelle titre vue mise à jour</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="libtitrevueedit">
                                                        <TextIndentLeft />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le titre à afficher lors de la mise à jour "
                                                        value={libtitrevueedit}
                                                        onChange={(e) => setLibtitrevueedit(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <button type="submit"
                                            title="Ajouter le nouveau domaine"
                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            disabled={(type["value"] === 1 || (type["value"] === 2 && nomtabparent["value"])) && libdom && nomtab  ? false : true}
                                        >
                                            <i className="fa fa-check mr-2"></i>
                                            <span>Ajouter</span> {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}